<template>
  <div class="list-like-game-bottom">
    <ul class="like-game-bottom-box" v-if="recommendPlayList && recommendPlayList.length">
      <template v-for="(item, index) in recommendPlayList">
        <li class="like-game-bottom-item" :key="index" v-if="item.busList && item.busList[0]">
          <img :src="item.icon" alt="" />
          <div class="like-con">
            <p>{{ item.name }}</p>
            <span>{{ item.description }}</span>
          </div>
          <p
            class="like-go"
            @click="
              goToZone({
                zoneConfig: item,
                busItem: item.busList[0],
                pfStructure: `${pfStructure}_button`,
                index: index + 1,
                iformatParam: `${reportDict.CLICK.GAME_ZONE_LIST_RECOMMEND_CARD}_${index + 1}`
              })
            "
          >
            进入
          </p>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import useZoneItem from "../../mixins/useZoneItem"
import * as reportDict from "../../../constants/report-dictonary"

export default {
  props: ["recommendPlayList", "pfStructure"],

  setup(props, { root }) {
    const { goToZone } = useZoneItem(root)

    return {
      goToZone,
      reportDict
    }
  }
}
</script>
